var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"#EBECF7","key":1}),React.createElement("path",{"d":"M20 15.8a4.1 4.1 0 000 8.3 4.1 4.1 0 000-8.3zm0 6.8a2.7 2.7 0 01-2.6-2.6c0-1.5 1.1-2.7 2.6-2.7s2.6 1.2 2.6 2.7c0 1.4-1.1 2.6-2.6 2.6zM24.3 16.7a1 1 0 100-1.9 1 1 0 000 1.9z","fill":"#6573FF","key":2}),React.createElement("path",{"d":"M26.7 13.3c-.8-.8-2-1.3-3.4-1.3h-6.6c-2.8 0-4.7 1.9-4.7 4.7v6.6c0 1.4.5 2.6 1.4 3.4.8.9 2 1.3 3.3 1.3h6.6c1.4 0 2.5-.4 3.4-1.3.8-.8 1.3-2 1.3-3.4v-6.6c0-1.4-.5-2.5-1.3-3.4zm-.1 10c0 1-.4 1.8-1 2.4-.5.5-1.3.8-2.3.8h-6.6c-1 0-1.8-.3-2.3-.8-.6-.6-1-1.4-1-2.4v-6.6c0-1 .4-1.8 1-2.4.5-.5 1.3-.8 2.3-.8h6.7c1 0 1.7.3 2.3.9.6.5.9 1.3.9 2.3v6.6z","fill":"#6573FF","key":3})]);
}

Instagram.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Instagram;

Instagram.default = Instagram;
